import urlParser from 'bloko/common/urlParser';

export default function usePreview(url: string): boolean {
    const { doPreview } = urlParser(url).params;
    return !!(doPreview as string[])?.includes('true');
}
